import { useEffect, useState } from 'react'

import { driversApi } from '@/api/drivers.api'
import type { Driver } from '@/types/driver'

import { useDebounce } from './useDebounce'

export const useDrivers = (search: string, enabled = true) => {
  const [data, setData] = useState<Driver[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<any>(null)

  const debouncedSearch = useDebounce(search, 300)

  useEffect(() => {
    if (!enabled) return

    const fetchDrivers = async () => {
      setIsLoading(true)
      try {
        const response = await driversApi.getDrivers({
          name: debouncedSearch,
          limit: 10
        })
        setData(response.Drivers ?? [])
        setError(null)
      } catch (err) {
        setError(err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchDrivers()
  }, [debouncedSearch, enabled])

  return { data, isLoading, error }
}
